import { fetchEntityChangeLog, resetEntityChangeLog } from '../../routines';

const initialState = {
  organization: {
    isLoading: false,
    log: [],
    cursor: undefined,
  },
  account: {
    isLoading: false,
    log: [],
    cursor: undefined,
  },
  contact: {
    isLoading: false,
    log: [],
    cursor: undefined,
  },
  pipeline: {
    isLoading: false,
    log: [],
    cursor: undefined,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch entity change-log
    case fetchEntityChangeLog.TRIGGER:
      return {
        ...state,
        [action.payload.level]: {
          isLoading: true,
          ...(action.payload.preservePreviousList
            ? {
                log: state[action.payload.level].log,
                cursor: state[action.payload.level].cursor,
              }
            : { log: [], cursor: undefined }),
        },
      };
    case fetchEntityChangeLog.SUCCESS:
      return {
        ...state,
        [action.payload.level]: {
          isLoading: false,
          log: action.payload.preservePreviousList
            ? [...state[action.payload.level].log, ...action.payload.log]
            : action.payload.log,
          cursor: action.payload.cursor,
        },
      };
    case fetchEntityChangeLog.FAILURE:
      return {
        ...state,
        [action.payload.level]: {
          ...state[action.payload.level],
          isLoading: false,
        },
      };

    // reset change-log data
    case resetEntityChangeLog.TRIGGER: {
      return {
        ...state,
        [action.payload.level]: {
          isLoading: false,
          log: [],
          cursor: undefined,
        },
      };
    }

    default:
      return state;
  }
};
